import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { getAppBasename, installDemoStorageNamespace } from './utils/runtimeMode';

installDemoStorageNamespace();

const App = require('./App').default;

// Get the root element
const container = document.getElementById('root');
const root = createRoot(container);

// Keep ONLY THIS Router in your entire application
root.render(
  <React.StrictMode>
    <BrowserRouter basename={getAppBasename()}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
